export default __webpack_public_path__ + "f18dab12b10a03d04bc0a9a562bc6f7f.png";